import axios from "axios";
import selectn from "selectn";
import {
  GET_STORY,
  GET_STORY_SUCCESS,
  GET_STORY_ERROR,
} from "../constants/actionTypes";

import { BACKEND_ROOT } from "../config/constants";

export const loadRevision = (storyId, revision, accessToken) => {
  return dispatch => {
    dispatch({
      type: GET_STORY,
    });

    return axios
      .request({
        method: "GET",
        url: `${BACKEND_ROOT}/api/content/${storyId}/revisions/${revision}/`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(response => {
        const payload =
          selectn("data.results[0]", response) ||
          (Array.isArray(response.data)
            ? selectn("data[0]", response)
            : response.data) ||
          null;
        return dispatch({
          type: GET_STORY_SUCCESS,
          payload,
        });
      })
      .catch(err => {
        dispatch({
          type: GET_STORY_ERROR,
          payload: err,
        });
      });
  };
};

export const loadLatest = (storyId, accessToken) => {
  return dispatch => {
    dispatch({
      type: GET_STORY,
    });

    return axios
      .request({
        method: "GET",
        url: `${BACKEND_ROOT}/api/content/${storyId}/`,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(response => {
        return dispatch({
          type: GET_STORY_SUCCESS,
          payload:
            "results" in response.data
              ? response.data.results[0]
              : response.data,
        });
      })
      .catch(err => {
        dispatch({
          type: GET_STORY_ERROR,
          payload: err,
        });
      });
  };
};
